<button *ngIf="!isVideoOpen" (click)="photoStart()" class="button">{{getShowCameraText()}}</button>
<div [class.is-hidden]="!isVideoOpen">
    <video #video width="640" height="480" autoplay></video>
</div>
<button *ngIf="isVideoOpen" (click)="photoSnap()" class="button">{{getTakePictureText()}}</button>
<br><br>
<div [class.is-hidden]="!isSnapTaken">
    <canvas #canvas style="width: 14em;" width="640" height="480"></canvas>
</div>